`<template>
  <div class="min-h-screen bg-gray-50">
    
    <div class="flex h-screen">
      <aside class="w-64 bg-white shadow-md hidden md:flex flex-col p-4">
        <h1 class="text-2xl font-bold text-green-700 mb-6">Admin Panel</h1>
        <nav class="flex flex-col space-y-2">
  <button class="text-left px-4 py-2 rounded-lg hover:bg-green-100" @click="viewSection = 'campaign'">
    📢 Campaign
  </button>

  <!-- Collapsible Articles -->
  <div>
    <button
      class="text-left px-4 py-2 rounded-lg hover:bg-green-100 w-full flex justify-between items-center"
      @click="showArticles = !showArticles"
    >
      <span>📄 Articles</span>
      <span>{{ showArticles ? '▲' : '▼' }}</span>
    </button>
    <!-- <div v-if="showArticles" class="ml-6 flex flex-col space-y-1"> -->
      <button class="text-left px-4 py-1 rounded hover:bg-green-50" @click="viewSection = 'articles'">✅ Published</button>
      <button class="text-left px-4 py-1 rounded hover:bg-green-50" @click="viewSection = 'pending'">⏳ Pending</button>
      <button class="text-left px-4 py-1 rounded hover:bg-green-50" @click="viewSection = 'reviewed'">📝 Reviewed</button>
    <!-- </div> -->
  </div>

  <button class="text-left px-4 py-2 rounded-lg hover:bg-green-100" @click="viewSection = 'users'">
    👥 Users
  </button>
  <button class="text-left px-4 py-2 rounded-lg hover:bg-green-100" @click="viewSection = 'stats'">
    📊 Dashboard
  </button>
  <button class="text-left px-4 py-2 rounded-lg hover:bg-red-100 text-red-600 mt-auto" @click="logout">
    🚪 Logout
  </button>
</nav>

      </aside>

      <main class="flex-1 p-6 overflow-auto">
        
        <header class="md:hidden flex justify-between items-center mb-6">
          <h2 class="text-xl font-bold text-green-700">Admin</h2>
          <button @click="logout" class="text-sm text-red-600 hover:underline">Logout</button>
        </header>

        
        <section v-if="viewSection === 'stats'">
          <h2 class="text-2xl font-semibold mb-4">Dashboard Overview</h2>
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div class="bg-white p-4 rounded-xl shadow">
              <p class="text-gray-500">Total Articles</p>
              <p class="text-3xl font-bold">{{ articles.length }}</p>
            </div>
            <div class="bg-white p-4 rounded-xl shadow">
              <p class="text-gray-500">Total Users</p>
              <p class="text-3xl font-bold">{{ users.length }}</p>
            </div>
            <div class="bg-white p-4 rounded-xl shadow">
              <p class="text-gray-500">Reviewers</p>
              <p class="text-3xl font-bold">{{ users.filter(u => u.role === 'reviewer').length }}</p>
            </div>
            <div class="bg-white p-4 rounded-xl shadow">
              <p class="text-gray-500">Editors</p>
              <p class="text-3xl font-bold">{{ users.filter(u => u.role === 'editor').length }}</p>
            </div>
            <div class="mt-8">
              <h3 class="text-xl font-semibold mb-2">Articles by Category</h3>
              <ul class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                <li v-for="(count, category) in articleStats" :key="category" class="bg-white p-4 rounded-lg shadow text-sm">
                  <p class="text-gray-600 font-medium">{{ category }}</p>
                  <p class="text-xl font-bold">{{ count }}</p>
                </li>
              </ul>
            </div>

          </div>
        </section>


        
        <section v-if="viewSection === 'articles'">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-2xl font-semibold">Published Research</h2>
            <button @click="openCreateModal" class="px-4 py-2 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700">+ New Article</button>
          </div>

          <table class="w-full bg-white rounded-xl shadow overflow-hidden">
            <thead class="bg-green-100 text-left text-sm text-green-800">
              <tr>
                <th class="px-4 py-2">Title</th>
                <th class="px-4 py-2">Category</th>
                <th class="px-4 py-2">Tags</th>
                <th class="px-4 py-2">Authors</th>
                <th class="px-4 py-2">Date Published</th>
                <th class="px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="article in publishedArticles" :key="article.id" class="border-t hover:bg-gray-50">
                <td class="px-4 py-2 font-medium">{{ article.title }}</td>
                <td class="px-4 py-2">{{ article.category }}</td>
                <td class="px-4 py-2">{{ formatTags(article.tags) }}</td>
                <td class="px-4 py-2">{{ article.authors?.join(', ') }}</td>
                <td class="px-4 py-2">{{ formatDate(article.publishedDate) }}</td>
                <td class="px-4 py-2">
                  <button @click="viewpub(article)" class="text-green-600 hover:underline mr-3">View</button>
                  <!-- <button @click="editArticle(article)" class="text-blue-600 hover:underline mr-3">Edit</button>
                  <button @click="deleteArticle(article.id)" class="text-red-600 hover:underline">Delete</button> -->
                    <button 
      @click="toggleFeatured(article)" 
      class="text-yellow-600 hover:underline mr-3"
    >
      {{ article.featured ? 'Unfeature' : 'Make Featured' }}
    </button>
                </td>
               
              </tr>
            </tbody>
          </table>
        </section>
        <section v-if="viewSection === 'pending'">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-2xl font-semibold">All Research Articles</h2>
            <button @click="openCreateModal" class="px-4 py-2 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700">+ New Article</button>
          </div>

          <table class="w-full bg-white rounded-xl shadow overflow-hidden">
            <thead class="bg-green-100 text-left text-sm text-green-800">
              <tr>
                <th class="px-4 py-2">Title</th>
                <th class="px-4 py-2">Category</th>
                <th class="px-4 py-2">Tags</th>
                <th class="px-4 py-2">Authors</th>
                <th class="px-4 py-2">Date Published</th>
                <th class="px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="article in pendingArticles" :key="article.id" class="border-t hover:bg-gray-50">
                <td class="px-4 py-2 font-medium">{{ article.title }}</td>
                <td class="px-4 py-2">{{ article.category }}</td>
                <td class="px-4 py-2">{{ formatTags(article.tags) }}</td>
                <td class="px-4 py-2">{{ article.authors?.join(', ') }}</td>
                <td class="px-4 py-2">{{ formatDate(article.publishedDate) }}</td>
                <td class="px-4 py-2">
                  <button @click="viewArticle(article)" class="text-green-600 hover:underline mr-3">View</button>
                  <button @click="editArticle(article)" class="text-blue-600 hover:underline mr-3">Edit</button>
                  <button @click="deleteArticle(article.id)" class="text-red-600 hover:underline">Delete</button>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <section v-if="viewSection === 'reviewed'">
          <div class="flex justify-between items-center mb-4">
              <h2 class="text-2xl font-semibold">Reviewed Research</h2>
            <button @click="openCreateModal" class="px-4 py-2 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700">+ New Article</button>
          </div>

          <table class="w-full bg-white rounded-xl shadow overflow-hidden">
            <thead class="bg-green-100 text-left text-sm text-green-800">
              <tr>
                <th class="px-4 py-2">Title</th>
                <th class="px-4 py-2">Category</th>
                <th class="px-4 py-2">Tags</th>
                <th class="px-4 py-2">Authors</th>
                <th class="px-4 py-2">Date Published</th>
                <th class="px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="article in reviewedArticles" :key="article.id" class="border-t hover:bg-gray-50">
                <td class="px-4 py-2 font-medium">{{ article.title }}</td>
                <td class="px-4 py-2">{{ article.category }}</td>
                <td class="px-4 py-2">{{ formatTags(article.tags) }}</td>
                <td class="px-4 py-2">{{ article.authors?.join(', ') }}</td>
                <td class="px-4 py-2">{{ formatDate(article.publishedDate) }}</td>
                <td class="px-4 py-2">
                  <button @click="publish(article)" class="text-green-600 hover:underline mr-3">Publish</button>
                  <button @click="decline(article)" class="text-blue-600 hover:underline mr-3">Reject</button>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        
         <section v-if="viewSection ==='campaign'">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-2xl font-semibold">Campaign Management</h2>
            <button @click="openCreateCampaign" class="px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700">+ Create</button>
          </div>
          <div class="flex space-x-4 mb-4">
            <button v-for="stats in status" :key="stats" @click="activeCampaign = stats" :class="['px-4 py-2 rounded-lg text-sm', activeCampaign === status ? 'bg-green-600 text-white' : 'bg-gray-200 text-gray-700']">
              {{ stats.charAt(0).toUpperCase() + stats.slice(1) }}s
            </button>
          </div>
          <table class="w-full bg-white rounded-xl shadow overflow-hidden">
            <thead>
              <tr class="border-b bg-green-100">
                <th class="text-left px-4 py-2">Title </th>
                <th class="text-left px-4 py-2">Duration</th>
                <th class="text-left px-4 py-2">status</th>
                <th class="text-left px-4 py-2">Submission</th>
                <th class="text-left px-4 py-2">Modify</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="campaign in filteredCampaign" :key="campaign.id" class="border-b hover:bg-gray-50">
                <td class="px-4 py-2">{{ campaign.title }}</td>
               <td class="px-4 py-2">{{ campaign.startDate.toDate().toLocaleDateString() }} - {{ campaign.endDate.toDate().toLocaleDateString() }}</td>
                <td class="px-4 py-2">
                 {{ campaign.status }}
                </td>
                <td class="px-4 py-2">
                  <input
                    type="checkbox"
                    :checked="campaign.submission === 'ON'"
                    @change="togglesubmission(campaign)"
                    class="w-4 h-4"
                  />
                </td>

               <td class="px-4 py-2">
                <button @click="shareCampaign(campaign)" class="text-blue-600 hover:underline mr-3">Share</button>
               </td>
              </tr>
            </tbody>
          </table>
         </section>
        
        <section v-if="viewSection === 'users'">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-2xl font-semibold">User Management</h2>
            <button @click="openInviteModal" class="px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700">+ Invite User</button>
          </div>


          <div class="flex space-x-4 mb-4">
            <button v-for="role in roles" :key="role" @click="activeRole = role" :class="['px-4 py-2 rounded-lg text-sm', activeRole === role ? 'bg-green-600 text-white' : 'bg-gray-200 text-gray-700']">
              {{ role.charAt(0).toUpperCase() + role.slice(1) }}s
            </button>
          </div>

          <table class="w-full bg-white rounded-xl shadow overflow-hidden">
            <thead>
              <tr class="border-b bg-green-100">
                <th class="text-left px-4 py-2">Name</th>
                <th class="text-left px-4 py-2">Email</th>
                <th class="text-left px-4 py-2">Role</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in filteredUsers" :key="user.id" class="border-b hover:bg-gray-50">
                <td class="px-4 py-2">{{ user.name }}</td>
                <td class="px-4 py-2">{{ user.email }}</td>
                <td class="px-4 py-2">
                  <select v-model="user.role" @change="updateUserRole(user)" class="border rounded px-2 py-1">
                    <option v-for="r in roles" :key="r" :value="r">{{ r }}</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>

<br>
  <h2 class="text-xl font-semibold mb-2">Pending Invitations</h2>
  <table class="w-full bg-white rounded-xl shadow overflow-hidden">
    <thead class="bg-gray-100 text-left text-sm text-gray-800">
      <tr>
        <th class="px-4 py-2">Email</th>
        <th class="px-4 py-2">Role</th>
        <th class="px-4 py-2">Sent At</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="invite in invitations" :key="invite.id" class="border-t hover:bg-gray-50">
        <td class="px-4 py-2">{{ invite.email }}</td>
        <td class="px-4 py-2 capitalize">{{ invite.role }}</td>
        <td class="px-4 py-2">{{ new Date(invite.sentAt.seconds * 1000).toLocaleString() }}</td>
      </tr>
    </tbody>
  </table>

        </section>

<div v-if="showShareModal" class="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center">
  <div class="bg-white p-6 rounded-xl w-full max-w-md">
    <h3 class="text-lg font-bold mb-4">Share Campaign</h3>
    <p class="text-sm text-gray-600 mb-4">You can share this campaign to Facebook using the button below.</p>

    <div class="bg-gray-100 p-3 rounded mb-4 text-sm break-words">{{ campaignShareUrl }}</div>

    <div class="flex justify-end gap-2">
      <button @click="closeShareModal" class="text-gray-600 hover:underline">Cancel</button>
      <a
        :href="`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(campaignShareUrl)}`"
        target="_blank"
        class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
      >Share on Facebook</a>
    </div>
  </div>
</div>

        
        <div v-if="showModal" class="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center">
          <div class="bg-white p-6 rounded-xl w-full max-w-xl">
            <h3 class="text-lg font-bold mb-4">{{ isEdit ? 'Edit Article' : 'New Article' }}</h3>

            <div class="space-y-4">
              <input v-model="form.title" type="text" placeholder="Title" class="w-full p-2 border rounded" />
              <input v-model="form.category" type="text" placeholder="Category" class="w-full p-2 border rounded" />
              <input v-model="form.tags" type="text" placeholder="Tags (comma-separated)" class="w-full p-2 border rounded" />
              <input v-model="form.authors" type="text" placeholder="Authors (comma-separated)" class="w-full p-2 border rounded" />
              <textarea v-model="form.abstract" rows="4" placeholder="Abstract" class="w-full p-2 border rounded"></textarea>
            </div>

            <div class="mt-6 flex justify-end gap-2">
              <button @click="closeModal" class="text-gray-600 hover:underline">Cancel</button>
              <button @click="submitArticle" class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">Save</button>
            </div>
          </div>
        </div>


<div v-if="showCampaignModal" class="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center">
  <div class="bg-white p-6 rounded-xl w-full max-w-xl">
    <h3 class="text-lg font-bold mb-4">Create Campaign</h3>

    <div class="space-y-4">
      <input v-model="campaignName" type="text" placeholder="Campaign Title" class="w-full p-2 border rounded" />

      <div class="flex gap-2">
        <input v-model="startDate" type="date" class="w-full p-2 border rounded" />
        <input v-model="endDate" type="date" class="w-full p-2 border rounded" />
      </div>

      <textarea v-model="campaignDetails" rows="4" placeholder="Campaign Details" class="w-full p-2 border rounded"></textarea>

      
<div
  class="border-2 border-dashed border-gray-300 p-6 rounded-lg text-center cursor-pointer hover:bg-gray-50"
  @dragover.prevent
  @drop.prevent="handleDrop"
  @click="$refs.bannerInput.click()"
>
  <input
    ref="bannerInput"
    type="file"
    class="hidden"
    accept="image/*"
    @change="handleBannerUpload"
  />
  <p class="text-gray-500" v-if="!campaignBanner">Drop image here or click to upload</p>
  <p class="text-green-600 text-sm" v-if="campaignBanner">Uploaded: {{ campaignBanner }}</p>
</div>

    </div>

    <div class="mt-6 flex justify-end gap-2">
      <button @click="closeCampaignModal" class="text-gray-600 hover:underline">Cancel</button>
      <button @click="saveCampaign" class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">Save</button>
    </div>
  </div>
</div>

        
        <div v-if="showInviteModal" class="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center">
          <div class="bg-white p-6 rounded-xl w-full max-w-md">
            <h3 class="text-lg font-bold mb-4">Invite User</h3>
            <div class="space-y-4">
              <input v-model="inviteEmail" type="email" placeholder="User Email" class="w-full p-2 border rounded" />

              <select v-model="inviteRole" class="w-full p-2 border rounded">
                <option disabled value="">Select Role</option>
                <option v-for="r in roles" :key="r" :value="r">
                  {{ r.charAt(0).toUpperCase() + r.slice(1) }}
                </option>
              </select>

            </div>
            <div class="mt-6 text-sm text-gray-700">
              <p>The user will receive a formal invitation to join the Mindoro State University - Daluyang Dunong Research Portal as a reviewer. They must click the link to accept and activate their account.</p>
            </div>
            <div class="mt-6 flex justify-end gap-2">
              <button @click="closeInviteModal" class="text-gray-600 hover:underline">Cancel</button>
              <button @click="sendInvitation" class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">Send Invite</button>
            </div>
          </div>
        </div>
        
<div v-if="showViewModal" class="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center">
  <div class="bg-white p-6 rounded-xl w-full max-w-xl">
    <h3 class="text-lg font-bold mb-4">{{ selectedArticle?.title }}</h3>

    <div class="space-y-2 text-sm text-gray-700">
      <p><strong>Category:</strong> {{ selectedArticle?.category }}</p>
      <p><strong>Tags:</strong> {{ selectedArticle?.tags?.join(', ') }}</p>
      <p><strong>Authors:</strong> {{ selectedArticle?.authors?.join(', ') }}</p>
      <p><strong>Abstract:</strong></p>
      <p class="text-justify">{{ selectedArticle?.abstract }}</p>
    </div>

    <div class="mt-6 flex justify-end">
      <button @click="closeViewModal" class="px-4 py-2 text-gray-600 hover:underline">Close</button>
    </div>
  </div>
</div>

      </main>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue'
import { collection, getDocs, updateDoc, doc, query, where, addDoc } from 'firebase/firestore'
import { db } from '@/firebase'

// Sections
const startDate = ref('')
const endDate = ref('')
const bannerInput = ref(null)

const viewSection = ref('stats')
const showShareModal = ref(false)
const campaignShareUrl = ref('')

// Article management
const articles = ref([])
const showModal = ref(false)
const isEdit = ref(false)
const showViewModal = ref(false)
const selectedArticle = ref(null)
const form = ref({ id: null, title: '', category: '', tags: '', authors: '', abstract: '' })

// User management
const users = ref([])
const invitations = ref([])
const campaign = ref([])
const roles = ['reviewer', 'editor', 'researcher']
const status = ['on-going', 'inactive', 'done']
const activeRole = ref('reviewer')
const activeCampaign = ref('on-going')
const showInviteModal = ref(false)
const showCampaignModal = ref(false)
const inviteEmail = ref('')
const inviteRole = ref('')
const campaignName = ref('')
const campaignDetails = ref('')
const campaignDuration = ref('')
const campaignBanner = ref('')
const  formatDate = (date) => {
    if (!date) return '';
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }
// const viewArticle = (article) => {
//   selectedArticle.value = article
//   showViewModal.value = true
// }
const viewArticle = (article) => {
  const routeUrl = `/article/${article.slug}/review`
  window.open(routeUrl, '_blank')
}
const viewpub = article => {
   const routeUrl = `/article/${article.slug}`
  window.open(routeUrl, '_blank')
}




const closeViewModal = () => {
  showViewModal.value = false
  selectedArticle.value = null
}

const publish = async (article) => {
  try {
    const articleRef = doc(db, 'articles', article.id)
    await updateDoc(articleRef, {
      status: 'published'
    })
    alert('Article published successfully.')
  } catch (error) {
    console.error('Error publishing article:', error)
    alert('Failed to publish article.')
  }
}

// Reject the article
const decline = async (article) => {
  try {
    const articleRef = doc(db, 'articles', article.id)
    await updateDoc(articleRef, {
      status: 'rejected'
    })
    alert('Article rejected successfully.')
  } catch (error) {
    console.error('Error rejecting article:', error)
    alert('Failed to reject article.')
  }
}
const articleStats = computed(() => {
  const byCategory = {}
  articles.value.forEach(article => {
    const category = article.category || 'Uncategorized'
    byCategory[category] = (byCategory[category] || 0) + 1
  })
  return byCategory
})

const togglesubmission = async (campaign) => {
  const newStatus = campaign.submission === 'open' ? 'closed' : 'open'

  try {
    const campaignRef = doc(db, 'campaign', campaign.id)
    await updateDoc(campaignRef, { submission: newStatus })
    campaign.submission = newStatus
    alert(`Submission status updated to ${newStatus}`)
  } catch (err) {
    console.error('Failed to update submission status:', err)
    alert('Failed to update submission status.')
  }
}

const fetchInvitations = async () => {
  try {
    const snapshot = await getDocs(query(collection(db, 'invitations'), where('status', '==', 'pending')))
    invitations.value = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
  } catch (err) {
    console.error('Failed to fetch invitations:', err)
  }
}

const shareCampaign = (campaign) => {
  const baseUrl = 'https://daluyangdunong.minsu.edu.ph/campaign'
  campaignShareUrl.value = `${baseUrl}/${campaign.slug}`
  showShareModal.value = true
}

const closeShareModal = () => {
  showShareModal.value = false
  campaignShareUrl.value = ''
}

const fetchArticles = async () => {
  try {
    const q = query(collection(db, 'articles'))
    const snapshot = await getDocs(q)
    articles.value = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
  } catch (err) {
    console.error('Failed to fetch articles:', err)
  }
}
const publishedArticles = computed(() => articles.value.filter(a => a.status === 'published'))
const pendingArticles = computed(() => articles.value.filter(a => a.status === 'pending'))
const reviewedArticles = computed(() => articles.value.filter(a => a.status === 'reviewed'))

const formatTags = (tagsArray) => {
  if (!tagsArray || !Array.isArray(tagsArray)) return ''
  const joined = tagsArray.join(', ')
  return joined.length > 20 ? joined.slice(0, 20) + '…' : joined
}

const handleBannerUpload = async (e) => {
  const file = e.target.files[0]
  if (!file) return

  const formData = new FormData()
  formData.append('file', file)

  try {
    const res = await fetch('https://daluyangdunong.minsu.edu.ph/api/upload.php', {
      method: 'POST',
      body: formData
    })

    const result = await res.json()
    if (result?.url) {
      campaignBanner.value = result.url
    } else {
      alert('Upload failed')
    }
  } catch (err) {
    console.error('Upload error:', err)
    alert('Failed to upload banner.')
  }
}

const generateSlug = (title, start, end) => {
  const formatted = `${title}-${start}-${end}`
  return formatted
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]/g, '')
}

// ✅ Send campaign to all registered emails
const notifyAllUsers = async (campaignData) => {
  try {
    const snapshot = await getDocs(collection(db, 'users'))
    const emails = snapshot.docs
      .map(doc => doc.data().email)
      .filter(email => !!email)

    for (const email of emails) {
      const payload = {
        email,
        subject: `New Research Campaign: ${campaignData.title}`,
        message: `
          Hello,

          We are pleased to announce a new research campaign:

          <strong>Title:</strong> ${campaignData.title}<br>
          <strong>Duration:</strong> ${campaignData.startDate.toLocaleDateString()} to ${campaignData.endDate.toLocaleDateString()}<br>
          <strong>Details:</strong> ${campaignData.details}<br><br>

          Kindly visit the portal for submission.

          <br><br>
          Regards,<br>
          MINSU Research Portal Team
        `
      }

      await fetch('https://daluyangdunong.minsu.edu.ph/api/send-campaign.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
    }

    console.log('Campaign sent to all users.')
  } catch (err) {
    console.error('Failed to notify users:', err)
  }
}
// ✅ Updated saveCampaign with notifyAllUsers
const saveCampaign = async () => {
  if (!campaignName.value || !campaignDetails.value || !startDate.value || !endDate.value) {
    return alert('Please complete all fields.')
  }

  try {
    const slug = generateSlug(campaignName.value, startDate.value, endDate.value)

    const campaignData = {
      title: campaignName.value,
      details: campaignDetails.value,
      startDate: new Date(startDate.value),
      endDate: new Date(endDate.value),
      banner: campaignBanner.value || '',
      status: 'on-going',
      slug,
      submission: 'open',
      createdAt: new Date()
    }

    await addDoc(collection(db, 'campaign'), campaignData)
    await notifyAllUsers(campaignData)

    alert('Campaign created and email notifications sent.')
    showCampaignModal.value = false
    fetchCampaign()
  } catch (err) {
    console.error('Error saving campaign:', err)
    alert('Failed to create campaign.')
  }
}

const fetchUsers = async () => {
  try {
    const snapshot = await getDocs(collection(db, 'users'))
    users.value = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
  } catch (err) {
    console.error('Failed to fetch users:', err)
  }
}

const fetchCampaign = async () => {
  try {
    const snapshot = await getDocs(collection(db, 'campaign'))
    campaign.value = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
  } catch (err) {
    console.error('Failed to fetch campaigns:', err)
  }
}

onMounted(() => {
  fetchUsers()
  fetchArticles()
  fetchCampaign()
  fetchInvitations()
  
})

const filteredUsers = computed(() => {
  return users.value.filter(u => u.role === activeRole.value)
})

const filteredCampaign = computed(() => {
  return campaign.value.filter(u => u.status === activeCampaign.value)
})

const updateUserRole = async (user) => {
  try {
    const userRef = doc(db, 'users', user.id)
    await updateDoc(userRef, { role: user.role })
    alert(`Updated ${user.name}'s role to ${user.role}`)
  } catch (err) {
    console.error(err)
    alert('Failed to update role.')
  }
}

const openCreateModal = () => {
  form.value = { id: null, title: '', category: '', tags: '', authors: '', abstract: '' }
  isEdit.value = false
  showModal.value = true
}

const closeModal = () => {
  showModal.value = false
}

const submitArticle = () => {
  const newArticle = {
    ...form.value,
    tags: form.value.tags.split(',').map(t => t.trim()),
    authors: form.value.authors.split(',').map(a => a.trim())
  }

  if (isEdit.value) {
    const index = articles.value.findIndex(a => a.id === form.value.id)
    if (index !== -1) articles.value[index] = newArticle
  } else {
    newArticle.id = Date.now()
    articles.value.push(newArticle)
  }
  closeModal()
}

const editArticle = (article) => {
  form.value = { ...article, tags: article.tags.join(', '), authors: article.authors.join(', ') }
  isEdit.value = true
  showModal.value = true
}

const deleteArticle = (id) => {
  articles.value = articles.value.filter(a => a.id !== id)
}

const openInviteModal = () => {
  inviteEmail.value = ''
  inviteRole.value = ''
  showInviteModal.value = true
}

const openCreateCampaign = () => {
  campaignName.value = ''
  campaignDetails.value = ''
  campaignDuration.value = ''
  campaignBanner.value = ''
  showCampaignModal.value = true
}

const closeInviteModal = () => {
  showInviteModal.value = false
}

const closeCampaignModal = () => {
  showCampaignModal.value = false
}
// ✅ Toggle article featured status
const toggleFeatured = async (article) => {
  try {
    const articleRef = doc(db, 'articles', article.id)
    await updateDoc(articleRef, {
      featured: !article.featured
    })

    // Update local state immediately
    article.featured = !article.featured

    alert(`Article "${article.title}" is now ${article.featured ? 'featured' : 'unfeatured'}.`)
  } catch (err) {
    console.error('Error updating featured status:', err)
    alert('Failed to update featured status.')
  }
}

const sendInvitation = async () => {
  if (!inviteEmail.value || !inviteRole.value) {
    return alert('Please enter both email and role.')
  }

  try {
    const inviteDoc = await addDoc(collection(db, 'invitations'), {
      email: inviteEmail.value,
      role: inviteRole.value,
      status: 'pending',
      sentAt: new Date()
    })

    const token = inviteDoc.id

    const response = await fetch('https://daluyangdunong.minsu.edu.ph/api/send-invite.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: inviteEmail.value,
        role: inviteRole.value,
        token,
        message: `You are formally invited to join the MINSU Research Portal as a ${inviteRole.value}.`
      })
    })

    if (!response.ok) throw new Error('Failed to send email')

    await fetchInvitations()
    alert('Invitation sent successfully.')
    closeInviteModal()
  } catch (err) {
    console.error(err)
    alert('Failed to send invitation.')
  }
}

const logout = () => {
  alert('Logging out...')
}
</script>
`